import API_ENDPOINTS from '../config/apiConfig';
import { api } from './api';

const BASE = API_ENDPOINTS.JOURNAL_CLOSEOUTS;

// Closeout rows (closed + reopened history) for a location + date range.
export const listJournalCloseouts = async ({ locationId, orgId, startDate, endDate } = {}) => {
  if (!locationId) throw new Error('locationId is required');
  const params = [`locationId=${locationId}`];
  if (orgId) params.push(`orgId=${orgId}`);
  if (startDate) params.push(`startDate=${startDate}`);
  if (endDate) params.push(`endDate=${endDate}`);
  const response = await api.get(`${BASE}?${params.join('&')}`);
  return response.data;
};

// Close one or more business dates. Requires journal write permission.
export const closeJournalDays = async ({ orgId, locationId, dates, note } = {}) => {
  const response = await api.post(BASE, { orgId, locationId, dates, note });
  return response.data;
};

// Reopen closed business dates. Org admins only.
export const reopenJournalDays = async ({ orgId, locationId, dates } = {}) => {
  const response = await api.post(`${BASE}/reopen`, { orgId, locationId, dates });
  return response.data;
};
